import { t } from "i18next";
import { Cell2Validator } from "../Cell2";

export const cell2Required: Cell2Validator = (value) =>
  value === undefined
    ? Promise.reject(Error(t("The field is mandatory")))
    : Promise.resolve();
